import { AxiosError, AxiosResponse } from 'axios'
import { FetchBaseQueryError } from '@reduxjs/toolkit/query/react'
import { SerializedError } from '@reduxjs/toolkit'

import {
  DocumentVerificationResult,
  FetchBaseQueryErrorType,
  IdentityDocumentVerificationStatus,
  IdentityVerificationDocument,
  PortalApiError,
  TransformedIdentityVerificationDocument,
} from './types'
import { PaymentSourceCaptureErrorResponse } from '@afterpay/types'

export const isAxiosError = (e: Error): e is AxiosError => (e as AxiosError).isAxiosError ?? false
export const isPortalApiError = (e: any): e is PortalApiError => typeof e?.errorCode === 'string'
export const isPortalAxiosError = (e: Error): e is AxiosError<PortalApiError> => isAxiosError(e) && isPortalApiError(e.response?.data)

export const isFetchBaseQueryError = (error?: FetchBaseQueryError | SerializedError): error is FetchBaseQueryErrorType => {
  return typeof error !== 'undefined' && 'data' in error
}

export const isPaymentsSourceCaptureApiError = (e: any): e is PaymentSourceCaptureErrorResponse => typeof e?.error?.code === 'string'

export const handleKasadaBlockResponseError = (kasadaErrorHandler: Function) => async (error: any) => {
  const kasadaResponseBodyRegexp = /KPSDK/
  const isKasadaBlockResponse = error.response?.status === 429 && kasadaResponseBodyRegexp.test(error.response?.data)
  if (isKasadaBlockResponse) {
    kasadaErrorHandler(error)
  }
  throw error
}

export const getHttpCorrelationId = (response: AxiosResponse): string => {
  let httpCorrelationId = ''
  const regexp = /http_correlation_id/i
  for (const [headerKey, headerValue] of Object.entries(response.headers)) {
    if (regexp.test(headerKey)) {
      httpCorrelationId = headerValue
    }
  }
  return httpCorrelationId
}
export const toVerifiedDocument = (documentVerificationResults: DocumentVerificationResult[]): IdentityVerificationDocument[] =>
  documentVerificationResults.reduce<IdentityVerificationDocument[]>((acc, item) => {
    if (item.status === IdentityDocumentVerificationStatus.VERIFIED) {
      return [...acc, item.type]
    }
    return acc
  }, [])
export const transformIdentityDocument = (identityVerificationDocument: IdentityVerificationDocument[]): TransformedIdentityVerificationDocument[] => {
  return identityVerificationDocument.map((doc) => {
    if (doc === IdentityVerificationDocument.LICENCE) {
      const splitDoc = doc.split('_')
      if (splitDoc[1]) {
        return splitDoc[1].toLowerCase() as TransformedIdentityVerificationDocument
      }
      // Handle the case where splitDoc[1] is undefined
      return '' as TransformedIdentityVerificationDocument
    }
    return doc.toLowerCase() as TransformedIdentityVerificationDocument
  })
}
